import Modal from "antd/es/modal/Modal";
import React from "react";
import style from "css/mypage.module.css";
import axios from "axios";
import { Button } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import { useTranslation } from "react-i18next";

export default function ResComfirmPop({ isOpenResConfirm, close, schedule }) {
  const payload = useSelector((state) => state.user);
  const { t, i18n } = useTranslation();
  const closePop = () => {
    close();
  };

  const dispatch = useDispatch();

  const downloadFile = (params) => {
    axios
      .post("/schedule/downloadFile", params, { responseType: "blob" })
      .then((response) => response.data)
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", params.ORI_FILE_NM);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };

  const datetimeConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("MMMM D, YYYY (ddd) - hh:mm A");
    } else {
      return moment(value).locale("ko").format("YYYY-MM-DD (dd) - a hh:mm");
    }
  };

  return (
    <div className="mypagedetailpopup">
      <Modal
        className={style.res_detail_popup}
        open={isOpenResConfirm}
        onCancel={closePop}
        maskClosable={false}
        footer={null}
        width={480}
        closable={false}
      >
        <div className={style.detailpop_body}>
          <div className={style.resConfirmPop_header}>
            <img
              src={
                process.env.REACT_APP_CLIENT_URL +
                "img/menu/meeting_confirm.png"
              }
              alt="meeting_confirm"
            />
            <div className={style.resConfirmPop_header_title}>
              {t("MESSAGE.MEETING_CONFIRM")}
            </div>
          </div>
          <div className={style.detailpop_title}>{schedule.TITLE}</div>
          <div className={style.detailpop_content}>
            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_TITLE")}
              </div>
              <div className={style.detailpop_content_body}>
                {schedule.TITLE}
              </div>
            </div>
            <div className={style.detailpop_content_line1}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_START")}
              </div>
              <div className={style.detailpop_content_body}>
                {datetimeConverter(schedule.START_TIME)}
              </div>
            </div>
            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_END")}
              </div>
              <div className={style.detailpop_content_body}>
                {datetimeConverter(schedule.END_TIME)}
              </div>
            </div>
            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_HOST")}
              </div>
              <div className={style.detailpop_content_body}>{payload.name}</div>
            </div>
            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_PLACE")}
              </div>
              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {schedule.ENDPOINT_LIST?.length > 0 ? (
                  schedule.ENDPOINT_LIST.map(
                    (endpoint) => endpoint.ENDPOINT_NM
                  ).join(", ")
                ) : (
                  <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                )}
              </div>
            </div>
            <div className={style.detailpop_content_line3}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_PTCP")}
              </div>
              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {schedule.PARTICIPANT_LIST?.length > 0 ? (
                  schedule.PARTICIPANT_LIST.map((participant, index) => (
                    <div key={index}>
                      {participant.MEMBER_NM} {participant.EMAIL}
                    </div>
                  ))
                ) : (
                  <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                )}
              </div>
            </div>

            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.ATTACHMENT")}
              </div>

              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {schedule.ATTACHMENT_LIST?.length > 0 ? (
                  schedule.ATTACHMENT_LIST.map((attachment, index) => (
                    <div key={index}>{attachment.name}</div>
                  ))
                ) : (
                  <div>{t("LABEL.NO_ATTACHMENT")}</div>
                )}
              </div>
            </div>

            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_CONTENT")}
              </div>
              <div className={style.detailpop_content_body2}>
                {schedule.CONTENTS}
              </div>
            </div>
          </div>
          <div className={style.detailpop_btn_area}>
            <Button
              type="primary"
              onClick={() => closePop()}
              className={style.detailpop_btn_close}
            >
              {t("BTN.OK")}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
